import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";
import linearGradient from "assets/theme/functions/linearGradient";

const { borderWidth, borderColor } = borders;
const { transparent, info } = colors;

// Shared checked background: white tick on a solid gradient fill
const CHECKED_BG = (color) =>
  `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), ${linearGradient(
    color,
    color
  )}`;

const checkedStyles = (color) => ({
  "&.Mui-checked": {
    color,
    "& .MuiSvgIcon-root": {
      backgroundImage: CHECKED_BG(color),
      borderColor: color,
    },
  },
  "&.MuiCheckbox-indeterminate": {
    color,
    "& .MuiSvgIcon-root": {
      borderColor: color,
    },
  },
});

const checkbox = {
  styleOverrides: {
    root: {
      "& .MuiSvgIcon-root": {
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        width: pxToRem(20),
        height: pxToRem(20),
        color: transparent.main,
        border: `${borderWidth[1]} solid ${borderColor}`,
        borderRadius: pxToRem(5.6),
      },
      "&:hover": {
        backgroundColor: transparent.main,
      },
      "&.Mui-focusVisible": {
        border: `${borderWidth[2]} solid ${info.main} !important`,
      },
    },

    // Every colour variant gets the same tick treatment, just with a different fill
    colorPrimary: checkedStyles(info.main),
    colorSecondary: checkedStyles(info.main),
    colorInfo: checkedStyles(info.main),
    colorSuccess: checkedStyles("#4CAF50"),
    colorWarning: checkedStyles("#fb8c00"),
    colorError: checkedStyles("#F44335"),
    colorDefault: checkedStyles(info.main),
  },
};

export default checkbox;
